import React from 'react';
import { UncontrolledTooltip } from 'reactstrap';
import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import editIcon from '../../assets/img/icons/edit-primary.svg';

function RequestForChangesTableRow({ item }) {
  const { id, serial, organization, description } = item;

  return (
    <>
      <td>
        <h5 className="fs-base my-1">{serial}</h5>
      </td>
      <td>
        <h5 className="fs-base mt-1 fw-normal">{organization.tradeName}</h5>
      </td>
      <td>
        <h5 className="fs-base mt-1 fw-normal">{description}</h5>
      </td>
      <td className="text-right">
        <Button
          className="btn-icon rounded-circle btn-ghost-light"
          id={`tooltip_edit${id}`}
          size="sm"
          type="button"
        >
          <img src={editIcon} alt="Edit icon" />
        </Button>
        <UncontrolledTooltip
          delay={0}
          className="uncontrolled-tooltip"
          target={`tooltip_edit${id}`}
        >
          Edit
        </UncontrolledTooltip>
      </td>
    </>
  );
}

RequestForChangesTableRow.propTypes = {
  item: PropTypes.object.isRequired,
};

export default RequestForChangesTableRow;
